import { render, staticRenderFns } from "./SmsBlocTextForm.vue?vue&type=template&id=7fa6e010"
import script from "./SmsBlocTextForm.vue?vue&type=script&lang=ts"
export * from "./SmsBlocTextForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports